import { render, staticRenderFns } from "./ContactUsPage.vue?vue&type=template&id=15bbf59f&scoped=true&"
import script from "./ContactUsPage.vue?vue&type=script&lang=js&"
export * from "./ContactUsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15bbf59f",
  null
  
)

export default component.exports